var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M-75,89c-6.7,0-12,5.3-12,12s5.3,12,12,12s12-5.3,12-12S-68.3,89-75,89z M-75,110.8c-5.5,0-9.8-4.4-9.8-9.8s4.3-9.8,9.8-9.8\n\ts9.8,4.4,9.8,9.8S-69.5,110.8-75,110.8z M-71,100h-8c-0.6,0-1,0.4-1,1s0.4,1,1,1h8c0.6,0,1-0.4,1-1S-70.4,100-71,100z"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4db6e8c0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/MinusIcon.vue
// module id = null
// module chunks = 